import React from 'react'
import { useFormState } from '../form/FormHandler'
import { COLORS } from '@btime/constants'
import Circle from '../../shapes/Circle'
import { Grid } from '../../structure/Grid'

const WeekDays = ({ disabled }) => {
  const { handleChangeIn, form } = useFormState()
  const options = [
    { id: 0, name: 'Domingo', subName: 'D' },
    { id: 1, name: 'Segunda', subName: 'S' },
    { id: 2, name: 'Terça', subName: 'T' },
    { id: 3, name: 'Quarta', subName: 'Q' },
    { id: 4, name: 'Quinta', subName: 'Q' },
    { id: 5, name: 'Sexta', subName: 'S' },
    { id: 6, name: 'Sábado', subName: 'S' }
  ]

  const onChange = item => {
    handleChangeIn(['weekday'], item.id)
  }

  return (
    <Grid gutter={0.3}>
      {options.map(opt => {
        const isSelected = form['weekday'] === opt.id
        const bgColor = isSelected ? null : COLORS.darkTransparent5
        const textColor = isSelected ? 'white' : COLORS.darkTransparent1
        return (
          <Circle key={opt.id} color={bgColor} onClick={() => !disabled && onChange(opt)}>
            <div style={{ color: textColor }}>{opt.subName}</div>
          </Circle>
        )
      })}
    </Grid>
  )
}

export default WeekDays
